<template>
  <v-row dense>
    <v-col>
      <v-card>
        <v-card-title>FILTRI</v-card-title>
        <v-card-text>
          <v-row>
            <v-col md="6" sm="5" xs="12">
              <v-autocomplete dense clearable :items="suppliers" v-model="filters.selectedSupplier" label="Fornitori"
                :loading="isLoading" :search-input.sync="search" hide-no-data hide-selected allow-overflow no-filter
                item-text="an_descr1" item-value="an_conto" prepend-icon="mdi-database-search">
              </v-autocomplete>
            </v-col>
            <v-col md="2" sm="5" xs="12">
              <v-text-field dense clearable label="Cod. Art. Fornitore" v-model="filters.codArtForn"></v-text-field>
            </v-col>
            <v-col md="2" sm="5" xs="12">
              <v-text-field dense clearable label="Codice a barre" v-model="filters.barcode"></v-text-field>
              <v-btn depressed small :to="{name: 'product-barcodescanner'}">scan <v-icon right dark>
                mdi-barcode</v-icon>
              </v-btn>
            </v-col>

            <v-col md="2" sm="2" xs="12">
              <v-checkbox dense v-model="filters.inStock" label="In Stock"></v-checkbox>
              <v-checkbox dense v-model="filters.noImageFilter" label="No image"></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="5" sm="6" xs="12">
              <v-autocomplete dense clearable :items="families" @change="changeFamilySelect('family')"
                v-model="filters.selectedFamily" label="Famiglie">
              </v-autocomplete>
            </v-col>
            <v-col md="5" sm="6" xs="12">
              <v-autocomplete dense clearable :items="subfamilies" @change="changeFamilySelect('subfamily')"
                v-model="filters.selectedSubFamily" label="Sotto Famiglie">
              </v-autocomplete>
            </v-col>
            <v-col md="2" sm="6" xs="12">
              <v-text-field dense clearable label="Codice Articolo" v-model="filters.codProdotto"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="3" sm="6" xs="6">
              <v-select dense clearable :items="orderOptions" v-model="selectedOrder" label="Ordinamento"></v-select>
            </v-col>
            <v-col md="2" sm="6" xs="6">
              <v-select dense :items="directionOptions" v-model="selectedDirection" label="Dierection"></v-select>
            </v-col>
            <v-col md="4" sm="6" xs="12">
              <v-text-field dense clearable label="Descrizione" v-model="filters.description"></v-text-field>
            </v-col>
            <v-col md="3" sm="6" xs="6" class="text-right">
              <v-btn depressed small @click="resetFilter"> Reset </v-btn>
              <v-btn depressed small color="primary" @click="sendSearch()">
                Cerca <v-icon right dark> mdi-magnify </v-icon>
              </v-btn>
              <div>
                Articoli trovati: <b>{{ numArticoli }}</b>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import requests from "../requests";
/**
 * ORdinare per codice articolo |
 * famiglia e sottofamiglia (ordine alfabetico) |
 * prezzo di vendia al pubblico "prezzo2" con sconto |
 * o dissede
 */
export default {
  name: "filters",
  props: {
    numArticoli: Number,
  },
  watch: {
    search(val) {

      //if (this.suppliers.length > 0) return
      // Items have already been requested

      if (this.filters.selectedSupplier != null) return;

      if (this.isLoading) return

      this.isLoading = true
      requests.getSuppliers(val)
        .then(res => {
          this.suppliers = res.data;
        })
        .finally(() => (this.isLoading = false))
    },
  },
  mounted() {
    console.log("Filters Component mounted.");
    this.filters.selectedSupplier = _.isUndefined(
      this.$route.query.cod_supplier
    )
      ? null
      : this.$route.query.cod_supplier;

    this.filters.dataCarico = _.isUndefined(this.$route.query.data_carico)
      ? null
      : this.$route.query.data_carico;

    this.getFamilies();
    //this.getSuppliers();
  },
  data: () => {
    return {
      isLoading: false,
      families: [],
      subfamilies: [],
      suppliers: [],
      search: null,
      directionOptions: [
        {
          text: "ASC",
          value: "asc",
        },
        {
          text: "DESC",
          value: "desc",
        },
      ],
      orderOptions: [
        {
          text: "Cod. Articolo",
          value: "order_art",
        },
        {
          text: "Famiglie",
          value: "order_families",
        },
        {
          text: "Sotto Famiglie",
          value: "order_subfamilies",
        },
        {
          text: "Prezzo",
          value: "order_price",
        },
        {
          text: "Giacenza",
          value: "order_giacenza",
        },
        {
          text: "Cod. Fornitore",
          value: "order_codforn",
        },
        {
          text: "Data Carico",
          value: "order_datacarico",
        },
      ],

      selectedOrder: null,
      selectedDirection: "asc",

      filters: {
        selectedFamily: null,
        selectedSubFamily: null,
        selectedSupplier: null,
        codArtForn: null,
        barcode: null,
        codProdotto: null,
        description: null,
        dataCarico: null,
        inStock: true,
      },
    };
  },
  methods: {
    changeFamilySelect(type) {
      if (type == "family") {
        this.getSubFamilies(this.filters.selectedFamily);
      }
    },

    getSuppliers() {
      let tmp = [];
      requests.getSuppliers().then((res) => {
        res.data.forEach((val) => {
          let testo = !_.isUndefined(val.AN_DESCR1)
            ? val.AN_CONTO + " - " + val.AN_DESCR1
            : val.AN_CONTO;
          let obj = {
            text: testo,
            value: val.AN_CONTO,
          };
          tmp.push(obj);
        });
      });
      this.suppliers = tmp;
    },

    getFamilies() {
      let tmp = [];
      requests.getFamilies().then((res) => {
        res.data.forEach((val) => {
          let obj = {
            text: val.ACL_DESCLA1,
            value: val.ACL_CODCLA1,
          };
          tmp.push(obj);
        });
        this.families = tmp;
      });
    },

    getSubFamilies(fid) {
      let tmp = [];
      requests.getSubFamilies(fid).then((res) => {
        res.data.forEach((val) => {
          let obj = {
            text: val.ACL_DESCLA2,
            value: val.ACL_CODCLA2,
          };
          tmp.push(obj);
        });
        this.subfamilies = tmp;
      });
    },
    resetFilter() {
      _.forEach(this.filters, (val, key) => {
        this.filters[key] = null;
      });
      this.filters.inStock = true;
    },
    sendSearch() {
      let normalizedFilter = {};

      let family = _.find(this.families, {
        value: this.filters.selectedFamily,
      });
      normalizedFilter["selectedFamily"] =
        _.isUndefined(family) || family.value == -1 ? null : family.text;

      let subFamily = _.find(this.subfamilies, {
        value: this.filters.selectedSubFamily,
      });
      normalizedFilter["selectedSubFamily"] =
        _.isUndefined(subFamily) || subFamily.value == -1
          ? null
          : subFamily.text;
      normalizedFilter = Object.assign(
        {
          order: this.selectedOrder,
          direction: this.selectedDirection,
        },
        this.filters,
        normalizedFilter
      );

      this.$emit("sendSearch", normalizedFilter);
    },
  },
};
</script>
